import React from 'react'
import Logo from '../common/Logo'

function LegalLayout({ titre, children, onRetour }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '0 0 60px' }}>
      <div style={{ background: 'white', borderBottom: '1px solid #e2e8f0', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
        <button onClick={onRetour} style={{ background: 'none', border: 'none', color: '#718096', cursor: 'pointer', fontSize: 14, display: 'flex', alignItems: 'center', gap: 6 }}>← Retour</button>
        <Logo size="sm" withText={true} />
      </div>
      <div style={{ maxWidth: 800, margin: '40px auto', padding: '0 24px' }}>
        <div style={{ background: 'white', borderRadius: 16, padding: '48px 56px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
          <h1 style={{ fontSize: 28, fontWeight: 800, color: '#0f172a', marginBottom: 8 }}>{titre}</h1>
          <p style={{ fontSize: 13, color: '#a0aec0', marginBottom: 40, borderBottom: '1px solid #f0f0f0', paddingBottom: 24 }}>
            Derniere mise a jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
          {children}
        </div>
      </div>
    </div>
  )
}

function H2({ children }) {
  return <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1D9E75', marginTop: 36, marginBottom: 12 }}>{children}</h2>
}
function P({ children }) {
  return <p style={{ fontSize: 15, color: '#4a5568', lineHeight: 1.75, marginBottom: 14 }}>{children}</p>
}

export default function CGU({ onRetour }) {
  return (
    <LegalLayout titre="Conditions Generales d Utilisation" onRetour={onRetour}>

      <H2>1. Objet</H2>
      <P>Les presentes Conditions Generales d Utilisation (CGU) regissent l acces et l utilisation de la plateforme Suiveo BTP, service de suivi de chantier disponible via navigateur web. En utilisant la plateforme, vous acceptez sans reserve l integralite des presentes CGU.</P>

      <H2>2. Acces au service</H2>
      <P>La plateforme Suiveo BTP est accessible a trois categories d utilisateurs :</P>
      <P><strong>Architectes / MOE :</strong> acces complet sur abonnement mensuel (20€/mois HT). Creation de chantiers, gestion des entreprises et clients, messagerie, documents, photos, comptes rendus PDF.</P>
      <P><strong>Entreprises :</strong> acces gratuit pour rejoindre les chantiers auxquels elles sont invitees. Gestion des taches assignees, upload de photos, messagerie.</P>
      <P><strong>Clients :</strong> acces en lecture seule, sans creation de compte, via un code a 6 caracteres communique par l architecte. Suivi de l avancement, galerie photos, consultation de documents.</P>

      <H2>3. Obligations de l utilisateur</H2>
      <P>En utilisant la plateforme, vous vous engagez a :</P>
      <P>— Fournir des informations exactes lors de la creation de votre compte et les maintenir a jour ;</P>
      <P>— Ne pas partager vos identifiants de connexion et etre responsable des actions effectuees sous votre compte ;</P>
      <P>— Utiliser la plateforme dans le cadre d une activite professionnelle liee au secteur du batiment et de la construction ;</P>
      <P>— Ne pas tenter d acceder de maniere non autorisee aux donnees d autres utilisateurs ;</P>
      <P>— Ne pas uploader de contenus illicites, offensants ou portant atteinte a des droits tiers.</P>

      <H2>4. Propriete intellectuelle</H2>
      <P>La plateforme Suiveo BTP, son code source, ses interfaces graphiques, sa marque et ses logos sont la propriete exclusive de [NOM DE LA SOCIETE]. Toute reproduction, modification ou exploitation sans autorisation expresse est interdite.</P>
      <P>Les contenus uploades par les utilisateurs (photos, documents) restent leur propriete. L utilisateur accorde a Suiveo BTP une licence limitee permettant l affichage et le stockage de ces contenus dans le cadre du service.</P>

      <H2>5. Disponibilite du service</H2>
      <P>Suiveo BTP s efforce de maintenir la plateforme accessible 24h/24 et 7j/7, mais ne peut garantir une disponibilite ininterrompue. Des interruptions pour maintenance ou amelioration pourront intervenir, de preference en dehors des heures ouvrables.</P>

      <H2>6. Responsabilite</H2>
      <P>Suiveo BTP est un outil de suivi et de communication. La responsabilite de Suiveo BTP est limitee aux dysfonctionnements directement imputables a la plateforme. Suiveo BTP n est pas responsable des decisions prises sur la base des informations saisies par les utilisateurs, ni des litiges entre architectes, entreprises et clients.</P>

      <H2>7. Modification des CGU</H2>
      <P>Suiveo BTP se reserve le droit de modifier les presentes CGU a tout moment. Les utilisateurs seront informes par email ou notification sur la plateforme. L utilisation continue du service apres modification vaut acceptation des nouvelles CGU.</P>

      <H2>8. Resiliation</H2>
      <P>Vous pouvez supprimer votre compte a tout moment en contactant notre support (suiveo.btp@gmail.com). En cas de violation des CGU, Suiveo BTP se reserve le droit de suspendre ou supprimer tout compte sans preavis.</P>

      <H2>9. Droit applicable</H2>
      <P>Les presentes CGU sont soumises au droit francais. En cas de litige, et apres tentative de resolution amiable, les tribunaux competents de [VILLE] seront seuls competents.</P>

      <H2>10. Contact</H2>
      <P>Pour toute question relative aux presentes CGU : <strong>suiveo.btp@gmail.com</strong></P>

    </LegalLayout>
  )
}
